import React from 'react';
import TableFooter from './TableFooter';

// A wrapper component that renders page content with TableFooter
const PageWithFooter = ({ children }) => {
  return (
    <div>
      {children}
      <div className="print-hide-footer">
        <TableFooter />
      </div>
    </div>
  );
};

export default PageWithFooter;
